
'use strict';

var perimeterx = require('_core_ext/trackers/perimeterx'),
    reserve = require('_core_ext/reservecollect/index');

var _ = require('lodash'),
    dialog = require('_core_ext/dialog'),
    progress = require('_core_ext/progress'),
    layout = require('_core_ext/layout'),
    util = require('_core_ext/util'),
    JSConstants = require('_core_ext/pages/cart/constants');

var $cache = {};
var layoutMode = layout.getMode();

function getSelectedDelivery() {
    var $deliveryTab = $(JSConstants.ID_CART_DELIVERY_TAB_DELIVERY),
        $collectTab = $(JSConstants.ID_CART_DELIVERY_TAB_COLLECT);

    var getSelectedOptionValue = function ($elem) {
        return typeof $elem.attr('checked') !== 'undefined' ? $elem.val() : false;
    };

    var collectValue = getSelectedOptionValue($deliveryTab);
    var deliveryValue = getSelectedOptionValue($collectTab);
    return deliveryValue || collectValue;
}

function removeUnavailable(e) {
    e.preventDefault();

    var $removeButton = $(e.target);
    var removeUrl = Urls.removeUnavailable;
    $removeButton.attr('disabled', true);
    progress.show();

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: removeUrl,
        data: {
            scope: 'all'
        }
    }).done(function (response) {

        if (response.success && typeof response.redirectLink === 'string') {
            window.location.replace(response.redirectLink);
        } else {
            progress.hide();
            $removeButton.attr('disabled', false);
        }
    }).fail(function (response) {
        perimeterx.handleResponce(response);
    });
}

function callChangeDelivery(selectedDelivery) {
    var cartUrl = Urls.changeDeliveryMethod;
    progress.show();

    $.ajax({
        type: 'POST',
        dataType: 'json',
        url: cartUrl,
        data: {
            delivery: selectedDelivery
        }
    }).done(function (response) {
        if (response.success) {
            // Cart will be reloaded for recalculate
            window.location.reload(true);
        } else {
            beforeDialogClose();
            dialog.close();
        }
    }).fail(function (response) {
        perimeterx.handleResponce(response);
    });
}

function beforeDialogClose() {
    // return back radio selector state
    var $deliveryTab = $(JSConstants.ID_CART_DELIVERY_TAB_DELIVERY),
        $collectTab = $(JSConstants.ID_CART_DELIVERY_TAB_COLLECT),
        deliveryChecked = $deliveryTab.attr('checked');

    if (typeof deliveryChecked !== 'undefined') {
        $deliveryTab.prop('checked', true);
    } else {
        $collectTab.prop('checked', true);
    }
}

function changeDelivery(e) {
    var input = e.target,
        newValue = input.value,
        isCollect = input.getAttribute('data-iscollect') === 'true',
        selectedStore = input.getAttribute('data-storeid'),
        oldValue = getSelectedDelivery();

    if (newValue && newValue.length > 0 && newValue !== oldValue) {
        var alertUrl = $(JSConstants.CLASS_CART_DELIVERY_TABS).data('alertdelivery');

        if (alertUrl) {
            dialog.open({
                url: alertUrl,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'reserve-delivery__dialog no-close',
                    beforeClose: beforeDialogClose
                },
                callback: function () {
                    $(JSConstants.CLASS_CHANGE_DELIVERY_YES).one('click', function () {
                        dialog.close();

                        if (isCollect && !selectedStore) {
                            reserve.showSelectStoreDialog({
                                eventTarget: input,
                                onClose: function () {
                                    callChangeDelivery(newValue);

                                    $(this).dialog('close');
                                    $(JSConstants.BODY).removeClass(JSConstants.LOCK);
                                }
                            });
                        } else {
                            callChangeDelivery(newValue);
                        }
                    });
                    $(JSConstants.CLASS_CHANGE_DELIVERY_NO).one('click', function () {
                        beforeDialogClose();
                        dialog.close();
                    });
                }
            });
        }
    }
}

function onCheckoutButton(e) {
    e.preventDefault();
    var $submitButton = $(e.target);

    submitCartForm($submitButton);
}


function checkDeliveryStickyState() {
    var defaultLayouts = ['mobile'];
    var stickyTabs = document.querySelector(JSConstants.CLASS_STICKY_TABS);

    if (defaultLayouts.indexOf(layoutMode) === -1) {
        stickyTabs.classList.add('hidden');
        stickyTabs.classList.remove('js-underline');
        return false;
    }

    var $deliveryTabsMock = $(JSConstants.ID_CART_DELIVERY_TABS_MOCK),
        $deliveryTabsSecondMock = $(JSConstants.ID_CART_DELIVERY_TABS_SECOND_MOCK),
        headerHeight = $('.js-sticky-header-mobile').outerHeight();

    if (stickyTabs && util.isElementUderHeader($deliveryTabsMock) && window.pageYOffset !== 0) {
        stickyTabs.classList.remove('hidden');
        stickyTabs.style.top = headerHeight + "px";
    } else {
        stickyTabs.classList.add('hidden');
    }

    if (stickyTabs && !stickyTabs.classList.contains('hidden') && util.isElementUderHeader($deliveryTabsSecondMock, stickyTabs)) {
        stickyTabs.classList.add('js-underline');
    } else {
        stickyTabs.classList.remove('js-underline');
    }

    return true;
}

function windowModeChanged(event, data) {
    if (data && data.mode) {
        layoutMode = data.mode;
    }
    checkDeliveryStickyState();
}

function submitCartForm($submitButton) {
    var action = $submitButton.attr('name');
    var $cartForm = $submitButton.closest('form' + JSConstants.CLASS_CHECKOUT_FORM);

    $cartForm.append($('<input />').attr({
        'type': 'hidden',
        'name': action
    }));

    $cartForm.trigger('submit');
}

function initializeCache() {
    $cache.document = $(document);
}

function initializeEvents() {
    checkDeliveryStickyState();
    var deliveryTabsHandler = _.throttle(checkDeliveryStickyState, 50, false);

    // select Delivery type functionality
    $(document)
        .on('click', JSConstants.ID_CART_DELIVERY_TAB_DELIVERY, changeDelivery)
        .on('click', JSConstants.ID_CART_DELIVERY_TAB_COLLECT, changeDelivery)
        .on('click', JSConstants.CLASS_CART_BUTTON_SUBMIT, onCheckoutButton)
        .on('click', JSConstants.CLASS_CART_BUTTON_REMOVE_UNAVAILABLE, removeUnavailable)
        .on('window.scroll', deliveryTabsHandler)
        .on('window.modechanged', windowModeChanged);
}

exports.init = function () {
    initializeCache();
    initializeEvents();
};
